module.exports = function() {
  return new Worker(__webpack_public_path__ + "d006056b6e12903c25ac.worker.js");
};